import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const Footer = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="py-12 bg-[#1C1C1E] border-t border-[#2C2C2E]"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <Link 
            to="/" 
            className="font-['Manrope'] font-bold text-xl text-[#F5F5F7] hover:opacity-70 transition-opacity"
          >
            Huacaya
          </Link>

          {/* Links */}
          <nav className="flex items-center gap-6 text-sm text-[#86868B]">
            <Link to="/guides" className="hover:text-[#F5F5F7] transition-colors">
              {t.nav.guides}
            </Link>
            <Link to="/blog" className="hover:text-[#F5F5F7] transition-colors">
              {t.nav.blog}
            </Link>
            <Link to="/privacy" className="hover:text-[#F5F5F7] transition-colors">
              {t.footer.privacy}
            </Link>
            <a 
              href="mailto:info@huacaya.io" 
              className="hover:text-[#F5F5F7] transition-colors"
            >
              {t.footer.contact}
            </a>
          </nav>

          {/* Language & Copyright */}
          <div className="flex items-center gap-4">
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-1.5 text-sm text-[#86868B] hover:text-[#F5F5F7] transition-colors"
              data-testid="footer-language-toggle"
            >
              <Globe className="w-4 h-4" />
              <span className="uppercase">{language}</span>
            </button>
            <span className="text-sm text-[#86868B]">
              © {currentYear} Huacaya. {t.footer.rights}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
